import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { AppProviders } from './app/providers'
import { AppRoutes } from './app/router'

import './styles/app.css'

const container = document.getElementById('root')
if (!container) throw new Error('No #root in index.html')

createRoot(container).render(
  <StrictMode>
    {/* The router is outermost because the session reads the URL: `?as=` picks
        the platform role, and a role decides which routes exist at all. */}
    <BrowserRouter>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </BrowserRouter>
  </StrictMode>,
)
